<script setup lang="ts" generic="T">
  import { computed } from 'vue';
  import Pagination from '../pagination/Pagination.vue';
  import type { EntityType } from '@/shared/lib';

  const props = defineProps<{
    items: T[];
    metadata?: { total?: number; totalItems?: number; page?: number } | null;
    selectedQuantity: number;
    entityName?: EntityType;
    hideSummary?: boolean;
  }>();

  defineEmits<{ 'page-changed': [page: number] }>();

  const totalItems = computed(() => props.metadata?.totalItems ?? props.metadata?.total ?? 0);
  const currentPage = computed(() => props.metadata?.page ?? 1);
</script>

<template>
  <slot
    name="table"
    :items="items"
  />
  <Pagination
    :total-items="totalItems"
    :items-per-page="Number(selectedQuantity)"
    :current-page="currentPage"
    :entity-name="entityName"
    :hide-summary="hideSummary ?? false"
    @page-changed="$emit('page-changed', $event)"
  />
</template>
